import dayjs from "dayjs"

const MILESTONE_KEYS = [
  "activity_due_date",
  "actual_completion_date",
  "compliance_due_date",
  "fcsr",
  "fpi",
  "fsa",
  "lpo",
  "pcd",
  "pra",
  "projected_completion_date",
  "request_due_date",
]

const getIsWorkflowComplete = (workflowTrackerData) => {
  const td = workflowTrackerData.state_data.tracker_data
  return td?.[td?.length - 1]?.is_current ? true : false
}

const getMilestones = (workflowTrackerData) => {
  let ret = []
  MILESTONE_KEYS.forEach((key) => {
    if (workflowTrackerData.parent_data?.[key]) {
      ret.push({
        type: key,
        value: workflowTrackerData.parent_data[key],
      })
    }
  })

  return ret
}

export const handleTrackerScroll = (event, wrapRef1, wrapRef2) => {
  const targetDiv = event.target
  var scrolling = false

  if (targetDiv === wrapRef1.current && wrapRef2.current) {
    if (scrolling) {
      scrolling = false
      return true
    }
    scrolling = true

    wrapRef2.current.scrollLeft = targetDiv.scrollLeft
  } else if (targetDiv === wrapRef2.current && wrapRef1.current) {
    if (scrolling) {
      scrolling = false
      return true
    }
    scrolling = true
    wrapRef1.current.scrollLeft = targetDiv.scrollLeft
  }
}

export const formatTrackerData = (workflowTrackerData) => {
  if (!workflowTrackerData?.state_data) return []
  const milestones = getMilestones(workflowTrackerData)
  const isWorkflowComplete = getIsWorkflowComplete(workflowTrackerData)

  let trackerData = workflowTrackerData?.state_data?.tracker_data?.slice(1)

  const today = dayjs()
  let foundToday = false

  if (trackerData.length > 0 && milestones) {
    const tempMilestones = milestones
      .filter((milestone) => {
        if (isWorkflowComplete && milestone.type === "projected_completion_date") return false
        return true
      })
      .map((milestone) => ({
        ...milestone,
        eligible: true,
      }))

    for (let i = trackerData.length - 1; i >= 0; i--) {
      let state = trackerData[i]
      let nextState = trackerData[i + 1]
      const isLast = i === trackerData.length - 1
      const isFirst = i === 0
      let isToday = false

      if (state.is_current && !state?.end_state_date) {
        state.end_state_date = nextState?.start_state_date
      }

      if (foundToday === false) {
        if (state?.start_state_date && today.isSame(state.start_state_date, "day")) {
          isToday = true
        } else if (
          trackerData?.[i + 1]?.start_state_date !== undefined &&
          today.isSame(trackerData?.[i + 1]?.start_state_date, "day")
        ) {
          isToday = true
        } else if (
          state?.start_state_date &&
          trackerData?.[i + 1]?.start_state_date &&
          today.isBetween(state.start_state_date, trackerData[i + 1].start_state_date)
        ) {
          isToday = true
        }

        if (isToday) {
          foundToday = true
        }
      }

      const stateMilestones = []
      tempMilestones.forEach((milestone) => {
        let milestoneDate = milestone.value

        if (milestone.eligible) {
          if (state.start_state_date && state.end_state_date) {
            let startDate = state.start_state_date
            let endDate = state.end_state_date

            if (
              dayjs(milestoneDate).isBetween(startDate, endDate) ||
              milestoneDate === startDate ||
              milestoneDate === endDate ||
              (isLast && dayjs(milestoneDate).isAfter(startDate)) ||
              (isFirst && dayjs(milestoneDate).isBefore(startDate))
            ) {
              stateMilestones.push(milestone)
              milestone.eligible = false
            }
          } else if (isFirst && dayjs(milestoneDate).isSameOrBefore(state.start_state_date)) {
            stateMilestones.push(milestone)
            milestone.eligible = false
          } else if (isLast && dayjs(milestone.value).isSameOrAfter(state.start_state_date)) {
            stateMilestones.push(milestone)
            milestone.eligible = false
          }
        }
      })

      state.milestones = stateMilestones
      state.isToday = isToday
    }
  }

  return trackerData
}
